import { render, staticRenderFns } from "./Styleguide.vue?vue&type=template&id=10ec91d6&"
import script from "./Styleguide.vue?vue&type=script&lang=ts&"
export * from "./Styleguide.vue?vue&type=script&lang=ts&"
import style0 from "./Styleguide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports